import { RouteName } from "@/router/types";
import { AppMenuItemsPos } from "@/helpers/constants";
import { AppMenuItem } from "@/services/apiService/api.types";

export interface SideBarState {
  sideBarOpen: boolean;
  appMenuItems: AppMenuItem[];
}

export const enum SideBarAction {
  UpdateAppMenuItems = "UpdateAppMenuItems"
}

export const enum SideBarMutation {
  SetSideBarOpen = "SetPause",
  SetAppMenuItems = "SetAppMenuItems"
}

export const enum SideBarGetter {
  GetSideBarOpen = "GetSideBarOpen",
  GetAppMenuItems = "GetAppMenuItems"
}

export interface NavItem {
  icon: string;
  routeName: RouteName;
  defaultElement: string;
  text: string;
  name: AppMenuItemsPos;
  position: number;
}
